var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{}\n"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("line",{"className":"st0","x1":"0","y1":"2.04","x2":"17.27","y2":"2.04","key":0}),React.createElement("g",{"key":1},React.createElement("polygon",{"className":"st1","points":"15.61,4.09 15.27,3.72 17.07,2.04 15.27,0.37 15.61,0 17.81,2.04 \t\t\t"}))]))]);
}

Arrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 17.81 4.09","style":{"enableBackground":"new 0 0 17.81 4.09"},"xmlSpace":"preserve"};

module.exports = Arrow;

Arrow.default = Arrow;
